<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ houseAddressTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ houseAddressSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- streetType & streetName -->
            <div class="form-row">
                <!-- streetType -->
                <div class="streetType">
                    <p-dropdown
                        placeholder="{{ streetTypeFloatLabel | translate }}"
                        formControlName="streetType"
                        id="streetType"
                        class=""
                        [options]="streetTypes"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeStreetType($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedStreetType">
                                <span class="float-label-dropdown">{{ streetTypeFloatLabel | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">{{ selectedStreetType.name }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-streetType pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ streetType.name }}
                                    <i *ngIf="streetType == selectedStreetType" class="ri-check-line class-icono-component"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>

                <!-- streetName -->
                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="streetName"
                            id="streetName"
                            name="streetName"
                            placeholder=""
                            (keyup)="onChangeStreetName($event)"
                        />
                        <label class="input-label" for="streetName">{{ streetNameLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.streetName.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- streetNumber & streetAdditionalInfo -->
            <div class="form-row">
                <div class="form-input-row streetNumber">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="streetNumber"
                            id="streetNumber"
                            name="streetNumber"
                            placeholder=""
                            (keyup)="onChangeStreetNumber($event)"
                        />
                        <label class="input-label" for="streetNumber">{{ streetNumberLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.streetNumber.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>

                <div class="form-input-row">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="streetAdditionalInfo"
                            id="streetAdditionalInfo"
                            name="streetAdditionalInfo"
                            placeholder=""
                            (keyup)="onChangeStreetAdditionalInfo($event)"
                        />
                        <label class="input-label" for="streetAdditionalInfo">{{ streetAdditionalInfoLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.streetAdditionalInfo.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div class="text-info">
                        <i class="ri-information-line"></i>
                        <span class="text-info-help">{{ infoStreetAdditionalInfo | translate }}</span>
                    </div>
                </div>
            </div>

            <!-- city & postalCode -->
            <div class="form-row">
                <!-- city -->
                <div class="city">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="city"
                            id="city"
                            name="city"
                            placeholder=""
                            (keyup)="onChangeStreetAdditionalInfo($event)"
                        />
                        <label class="input-label" for="city">{{ cityFloatLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.city.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
                
                <!-- postalCode -->
                <div class="form-input-row postalCode">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="postalCode"
                            id="postalCode"
                            name="postalCode"
                            placeholder=""
                            (keyup)="onChangePostalCode($event)"
                        />
                        <label class="input-label" for="postalCode">{{ postalCodeLabel | translate }}</label>

                        <div *ngIf="this.formGroup.controls.postalCode.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!--province-->
            <div class="form-row">
                <div class="form-field">
                    <p-dropdown
                        placeholder="{{ provinceFloatLabel | translate }}"
                        formControlName="province"
                        id="province"
                        class=""
                        [options]="provinces"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeProvince($event)"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="38"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedProvince">
                                <span class="float-label-dropdown">{{ provinceFloatLabel | translate }}</span>
                                <div class="data-field-value-dropdown-item-selected">{{ selectedProvince.name | titlecase }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-province pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ province.name }}
                                    <i *ngIf="province == selectedProvince" class="ri-check-line class-icono-component"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
